<template>
  <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: "Mises à jour",
          icon: "bi bi-arrow-repeat",
          route: "updates-index",
        },
        {
          label: "Nouvelle mise à jour",
          icon: "bi bi-cloud-upload-fill",
          route: "updates-create",
        },
      ],
    };
  },
};
</script>
